export default __webpack_public_path__ + "static/media/bird-head-new.5803b0c7.jpg";